import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["chronicPainList", "chronicPainSection", "pathologySelect"]

  static values = {
    appointmentId: Number,
    chronicPain: { type: Object, default: {} },
    labels: { type: Object, default: {} },
    chronicPainSuffix: { type: String, default: " est chronique ?" },
    selectedPathologyIds: { type: Array, default: [] }
  }

  connect () {
    this.onPathologyChange = () => this.renderChronicPainCheckboxes()
    this.modal = this.element.closest(".modal")

    if (this.modal) {
      this.onModalShown = () => {
        window.setTimeout(() => {
          this.bindTomSelect()
          this.renderChronicPainCheckboxes()
        }, 0)
      }
      this.modal.addEventListener("shown.bs.modal", this.onModalShown)

      if (this.modal.classList.contains("show")) {
        window.setTimeout(() => {
          this.bindTomSelect()
          this.renderChronicPainCheckboxes()
        }, 0)
      }
      return
    }

    this.pathologySelectTarget.addEventListener("change", this.onPathologyChange)
    this.renderChronicPainCheckboxes()
  }

  disconnect () {
    this.pathologySelectTarget.removeEventListener("change", this.onPathologyChange)
    this.unbindTomSelect()

    if (this.onModalShown) {
      this.modal?.removeEventListener("shown.bs.modal", this.onModalShown)
    }
  }

  bindTomSelect () {
    const tomSelect = this.pathologySelectTarget.tomselect

    if (!tomSelect || this.tomSelectBound) return

    tomSelect.on("change", this.onPathologyChange)
    this.tomSelectBound = true
  }

  unbindTomSelect () {
    const tomSelect = this.pathologySelectTarget.tomselect

    if (tomSelect && this.tomSelectBound) {
      tomSelect.off("change", this.onPathologyChange)
      this.tomSelectBound = false
    }
  }

  renderChronicPainCheckboxes () {
    this.bindTomSelect()

    const selectedIds = this.selectedPathologyIds()
    const chronicPainState = this.currentChronicPainState()

    this.chronicPainListTarget.innerHTML = selectedIds.map((pathologyId) => {
      const checked = chronicPainState[pathologyId] ? "checked" : ""
      const label = this.labelsValue[pathologyId] || pathologyId
      const inputId = `appointment_report_chronic_pain_${this.appointmentIdValue}_${pathologyId}`

      return `
        <div class="form-check mb-1" data-pathology-id="${pathologyId}">
          <input type="checkbox"
                 name="appointment_report[chronic_pain][${pathologyId}]"
                 id="${inputId}"
                 value="1"
                 class="form-check-input"
                 ${checked} />
          <label class="form-check-label" for="${inputId}">
            ${label}${this.chronicPainSuffixValue}
          </label>
        </div>
      `
    }).join("")

    this.chronicPainSectionTarget.hidden = selectedIds.length === 0
  }

  selectedPathologyIds () {
    const tomSelect = this.pathologySelectTarget.tomselect

    if (tomSelect) {
      const value = tomSelect.getValue()

      if (Array.isArray(value)) return value.filter(Boolean).map(String)

      return value ? [String(value)] : []
    }

    const fromSelect = Array.from(this.pathologySelectTarget.selectedOptions)
      .map((option) => option.value)
      .filter(Boolean)

    if (fromSelect.length > 0) return fromSelect

    return this.selectedPathologyIdsValue.map(String)
  }

  currentChronicPainState () {
    const state = { ...this.chronicPainValue }

    this.chronicPainListTarget.querySelectorAll("[data-pathology-id]").forEach((row) => {
      const pathologyId = row.dataset.pathologyId
      const checkbox = row.querySelector('input[type="checkbox"]')

      if (checkbox) {
        state[pathologyId] = checkbox.checked
      }
    })

    return state
  }
}
